export let dateMixin = {
    name:"dateMixin",
    methods:{
        // traduction EN en FR
        // Thu Apr 14 2022 09:30:00 GMT+0300 (heure normale d’Afrique de l’Est) en
        // date = date longue
        fullDateFr(date){
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
            date = date.toLocaleDateString('fr-FR', options)
            return date
        },
        formatDate(dateString){
            // prendre le décalage horaire
              let utc = dateString.charAt(21)
              let date = new Date(dateString)
              console.log(date.toISOString());
              let originalUTC = date.toISOString().split('T')[1].slice(0,5)
              let getHour = parseInt(originalUTC.split(':')[0])
              let displayedHour = getHour + parseInt(utc)
              console.log({originalUTC});
              console.log({getHour});
              console.log({displayedHour});
      
              // date = date.toISOString().split('T')[0]+' '+ date.toISOString().split('T')[1].slice(0,5)
              date = date.toISOString().split('T')[0]+' '+ displayedHour.toString()+date.toISOString().split('T')[1].slice(2,5)
              return date
        },
        // date String en DD-MM-YYYY
        formatDate2(date){
            // récupérer le jour, mois et année
            let date1= date.substring(0,11)
            // diviser par -
            let date2 = date1.split('-')
            // reformater
            let date3 = date2[2]+'-'+date2[1]+'-'+date2[0]
            //supprimer le T de la date
            let date4 = date3.replace('T','')
            return date4
        },
        // date String en YYYY-MM-DD
        formatDate3(date){
            // récupérer le jour, mois et année
            let date1= date.substring(0,11)
            // diviser par -
            let date2 = date1.split('-')
            // reformater
            let date3 = date2[0]+'-'+date2[1]+'-'+date2[2]
            //supprimer le T de la date
            let date4 = date3.replace('T','')
            return date4
        },
        // nombre(ex: 0.75) en MM:HH (ex:00:45)
        calculTimes(floatTime){
            var sec = 3600 * floatTime
            var date = new Date(0);
            // console.log('date in calcul times', date)
            date.setSeconds(sec);
            var timeString = date.toISOString().substr(11, 5);
            return timeString
        },

         // hh:MM(00:45) en nombre (0.75)
         TimeToFloat(time){
            // cette méthode est à revoir
            function decimalAdjust(type, value, exp) {
            // Si l'exposant vaut undefined ou zero...
            if (typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
            }
            value = +value;
            exp = +exp;
            // Si value n'est pas un nombre // ou si l'exposant n'est pas entier
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
            }
            // Décalage
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            // Re "calage"
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }
        // Arrondi décimal
        if (!Math.round10) {
            Math.round10 = function(value, exp) {
            return decimalAdjust('round', value, exp);
            };
        }
        // Arrondi décimal inférieur
        if (!Math.floor10) {
            Math.floor10 = function(value, exp) {
            return decimalAdjust('floor', value, exp);
            };
        }
        // Arrondi décimal supérieur
        if (!Math.ceil10) {
            Math.ceil10 = function(value, exp) {
            return decimalAdjust('ceil', value, exp);
            };
        }
            const h = Number(time.substr(0,2))
            const m = Number(time.substr(3,2)) /60
            let floatTime = h + m
            return Math.ceil10(floatTime, -2)
        },

        //arrondi à 5mn près de l'heure et minute
        roundedToNearestFive(date){
            let date_2 = new Date(date)
            const minutes = 5;
            const ms = 1000 * 60 * minutes;
            // utiliser round si on veut atteindre le nombre prêt
            return new Date(Math.ceil(date_2.getTime() / ms) * ms);
        },

        // transcrire date en français
        getDate(date){
            console.log("date dans getdate()",date);
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
            date = date.toLocaleDateString('fr-FR', options)
            return date
        },
        // transcrire date en français sans UTC timezone
        dateToFr2(date){
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
            let date2 = new Date(date)
            let date3 = date2.toLocaleDateString('fr-FR', options)
            return date3 + ' à ' + date.slice(11,16)
        },
        // prendre la date la plus lointaine
        getMinDate(a){
           return new Date(Math.min(...a.map(e => new Date(e.MeasureDate))));
        }
        
    }
}